export function validateMonoForm(data) {
    let errors = {};
    if (!data.title || data.title == '' || data.title == ' ')
        errors.title = 'Title is required';

    if (!data.authors || data.authors == '' || data.authors == ' ')
        errors.authors = 'Authors are required';

    if (!data.publisher || data.publisher == '' || data.publisher == ' ')
        errors.publisher = 'Publisher is required';

    if (!data.year || data.year == '' || data.year == ' ')
        errors.year = 'Year is required';

    if (!data.full_pages || data.full_pages == 0 || data.full_pages == null)
        errors.full_pages = 'Pages are required';

    if (!data.isbn || data.isbn == '' || data.isbn == ' ')
        errors.isbn = 'ISBN is required';

    if (!data.city || data.city == '' || data.city == ' ')
        errors.city = 'City is required';

    console.log(errors);
    if (Object.keys(errors).length > 0) {
        return errors;
    } else {
        return true;
    }
}